import {configureStore} from '@reduxjs/toolkit'
import {api} from "./middleware/api";
import invoices from "./invoices"
import manifest from "./manifest"
import serial_numbers from "./serial_numbers"
import login from "./logIn"


export default configureStore({
    reducer: {
        invoices, login, serial_numbers, manifest
    },
    middleware: [
        api,
    ]
})